export const downloadDocument = (url: string, fileName = ''): void => {
  const downloadLink = document.createElement('a');

  downloadLink.target = '_blank';
  downloadLink.href = url;
  downloadLink.download = fileName;
  downloadLink.click();
};
